import React, { Component } from 'react';
import { Form, Message, Label, Header } from 'semantic-ui-react';
import PhoneInput from 'react-phone-number-input';

class InsuredContactInfo extends Component {

    constructor(props) {
        super(props);

        this.state = {
            contactInfoErrors: [],
        };
    }

    handleinsuredPhoneNumberChange = (value) => {
        this.props.onInsuredContactInfoChange({
            target: {
                name: 'insuredPhoneNumber',
                value: value
            }
        });
    }

    validateEmail = (email) => {
        const regexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regexp.test(email);
    }

    validateContactForm = () => {
        let { contactInfoErrors } = this.state;
        contactInfoErrors = [];

        if (this.props.insuredFullName === '') {
            contactInfoErrors.push('Full name is required.');
        }

        if (this.props.insuredPhoneNumber === '') {
            contactInfoErrors.push('Phone number is required.');
        }

        if (!this.validateEmail(this.props.insuredEmailAddress)) {
            contactInfoErrors.push('The email you entered is not a valid email address.');

        }

        if (this.props.insuredEmailAddress === '') {
            contactInfoErrors.push('Email is required.');
        }

        if (contactInfoErrors.length === 0) {
            this.props.goToNextStep();
        }

        this.setState({ contactInfoErrors: contactInfoErrors });
    }

    render() {
        const { contactInfoErrors } = this.state;
        const { readOnly } = this.props;

        return (
            <Form as='div'>
                <label>Please enter the contact information of the Insured</label>
                <br />
                <br />
                <Form.Group>
                    <Form.Input
                        label='Full Name'
                        placeholder='Full Name'
                        width={10}
                        name='insuredFullName'
                        value={this.props.insuredFullName}
                        onChange={this.props.onInsuredContactInfoChange}
                        maxLength={50}
                        disabled={readOnly}
                    />
                    <Form.Field  width={6}>
                        <label>Phone Number</label>
                        <PhoneInput
                            placeholder='Phone'
                            value={this.props.insuredPhoneNumber}
                            onChange={value => this.handleinsuredPhoneNumberChange(value)}
                            name='insuredPhoneNumber'
                            country='US'
                            international={false}
                            showCountrySelect={false}
                            limitMaxLength={true}
                            disabled={readOnly}
                        />
                    </Form.Field>
                </Form.Group>
                <Form.Group>
                    <Form.Input
                        label='Email'
                        placeholder='Email'
                        width={16}
                        name='insuredEmailAddress'
                        value={this.props.insuredEmailAddress}
                        onChange={this.props.onInsuredContactInfoChange}
                        maxLength={100}
                        disabled={readOnly}
                    />
                </Form.Group>
                {contactInfoErrors.length > 0 && (
                    <Message
                        error
                        header='There was some errors.'
                        list={contactInfoErrors}
                    />
                )}
            </Form>
        );
    }
}

export default InsuredContactInfo;